export default "__VITE_ASSET__DfLw6oO6__"